import { css } from 'styled-components'

export const pageCenter = css`
  min-height: calc(100vh - 6rem);
  margin: 0 auto 10rem;
  max-width: 52.5rem;
  padding-top: 2rem;
`
